module.exports = __webpack_public_path__ + "static/media/icon-facebook.6fd0e324.svg";